// @flow

import React, {Component} from 'react';
import {shouldUpdate} from '@pb/kit-util-should-update';
import {hashedClasses} from '@pb/kit-util-with-css-module';

import {TreeContainer} from './tree-container.component';
import {getTreeDepth} from './utils';
import {PrefixTypes} from './constants';
import styles from './tree.component.module.styl';

import type {Element} from 'react';

import type {TreeStructure, ExpandedTree, NodeProps} from './typedef';
import type {PrefixType} from './constants';


const classes = hashedClasses(styles);

type Props = {|
    /**
     * All tree nodes
     */
    data: TreeStructure,
    /**
     * Expanded tree node ids
     */
    expandedIdsTree: ExpandedTree,
    /**
     * Set component to disabled state
     */
    disabled: boolean,
    /**
     * Type of prefix
     */
    prefixType: PrefixType,
    /**
     * Update expanded tree node ids
     */
    updateExpandedIds: (expandedIdsTree: ExpandedTree) => void,
    /**
     * Render tree node
     */
    getNode: (props: NodeProps) => Element<any>,
|};

type State = {|
    expandedIdsTree: ExpandedTree,
|};

export class Tree extends Component<Props, State> {
    static defaultProps = {
        expandedIdsTree: {},
        prefixType: PrefixTypes.NONE
    };

    state = {
        expandedIdsTree: this.props.expandedIdsTree
    };

    componentDidUpdate(prevProps: Props) {
        const {expandedIdsTree} = this.props;

        if (shouldUpdate(this.props, prevProps, ['expandedIdsTree'])) {
            this.setState({expandedIdsTree});
        }
    }

    updateExpandedIds = (expandedIdsTree: ExpandedTree) => {
        this.setState({expandedIdsTree});
        this.props.updateExpandedIds(expandedIdsTree);
    };

    render() {
        const {expandedIdsTree} = this.state;
        const {getNode, data, disabled, prefixType} = this.props;

        return (
            <div className={classes.tree} role="tree">
                <TreeContainer
                    {...{
                        expandedIdsTree,
                        updateExpandedIds: this.updateExpandedIds,
                        data,
                        getNode,
                        disabled,
                        prefixType,
                        isFlat: getTreeDepth(data) === 1
                    }}
                />
            </div>
        );
    }
}
